import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Observable, catchError, EMPTY, tap } from 'rxjs';
import { ApiService } from '../services/api.service';
import { UtilityService } from '../services/utility.service';
import { webRedirectionUrl } from '../constants/web-redirection-url';
import { NavigationService } from '../services/navigation.service';
import { AnalyticsService } from '../services/analytics.service';

export const toolkitDetailResolver: ResolveFn<Observable<any>> = (
  route: ActivatedRouteSnapshot,
) => {
  const slug: string = route.params['slug'].split('.html')[0];
  const apiService = inject(ApiService);
  const utilityService = inject(UtilityService);
  const navigationService = inject(NavigationService)
  const analyticsService = inject(AnalyticsService);

  if (utilityService.isUserLoggedIn()) {
    const url = `${webRedirectionUrl.toolkitDetails}${slug}`;
    utilityService.saveUrlandRedirect(url);
    return EMPTY;
  } else {
    return apiService.fetchToolkitDetails(slug).pipe(
      tap((data: any) => {
        analyticsService.logEvent('toolkit_view', {
          id: data?.id,
          name: data?.name,
          slug: data?.slug,
        });
      }),
      catchError((error) => {
      navigationService.handleResolverError(error)
        return EMPTY;
      }),
    );
  }
};
